var map = {
	"./Roulette.svg": 9042,
	"./bannerLogo.svg": 2280,
	"./bar.svg": 578,
	"./dontDrunkDrive.svg": 8265,
	"./icon-All.svg": 8008,
	"./icon-brandy.svg": 3196,
	"./icon-gin.svg": 5691,
	"./icon-rum.svg": 3525,
	"./icon-tequila.svg": 8658,
	"./icon-vodka.svg": 4826,
	"./icon-whisky.svg": 5685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;